import React, { useEffect, useState, useRef } from 'react';

import imgMy from '@/assets/images/index/btnMy.png';
import imgRule from '@/assets/images/rule.png';
import item4 from '@/assets/images/item4.png';

import Btn from '../components/btn';
import ShowGetWish from '../components/dialog/getWish';
import ShowMyWish from '../components/dialog/myWish';
import ShowRule from '../components/dialog/rule';
import ShowWishDetail from '../components/dialog/wishDetail';

import {useLogin} from '@/hooks';
import styles from './index.less';

const Page = (props) => {
  
  const auth = useLogin();  
  const onRandWish= async ()=>{
    const loginReq = await auth.login();
    if(loginReq){
      const wish = await ShowGetWish();
      if(wish&&wish=='change'){
        onRandWish();
        return;
      }
      if(wish){
        ShowWishDetail(wish);
        // sessionStorage.setItem('wish',JSON.stringify(wish))
        // location.href=`/#/wishDetail/${wish.id}`
      } 
    }
  }
  const onMyWishes= async ()=>{
    const loginReq = await auth.login();
    if(loginReq){
      ShowMyWish();
    }
  }

  return (
    <section className={styles.wrap} data-active={props.show}>
      <section className={styles.block1}>
        <img className={styles.my} src={imgMy} onClick={onMyWishes} />
        <img src={item4} className={styles.item4} />


        <Btn className={styles.btnGet} label='get' onClick={onRandWish} />
        <img src={imgRule} className={styles.rule} onClick={()=>{ShowRule()}} />
        <div className={styles.anStar} />
      </section>
    </section>
  )
}

export default Page;